// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width:1200px){.img-home[data-v-683f433c]{display:none}.btn[data-v-683f433c]{margin-top:35px}}", ""]);
// Exports
module.exports = exports;
